module.exports = __webpack_public_path__ + "img/Agencia Segura.a2d10e00.svg";